import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { FAQItemProps } from '@zola/zola-ui/src/components/PreAuthV3/FAQItem';
import { Fragment } from 'react';

export const FAQItems: FAQItemProps[] = [
  {
    answer:
      'You bet! You can text or email our handy form, or let us message your family and friends (even your parents) for you. Then we’ll update your guest list with their info, making it easy for you to make sure everyone you want is invited.',
    question: 'Wait, are Zola’s wedding planning tools free?',
  },
  {
    answer: (
      <Fragment>
        Our wedding{' '}
        <LinkV2 inline variant="tertiary" subtle href="/wedding-planning/checklist">
          checklist
        </LinkV2>{' '}
        is an easy way to figure out what you need to do, which vendors to book, and when. Couples
        also build their wedding website and send save the dates early on. Check our{' '}
        <LinkV2 inline variant="tertiary" subtle href="/expert-advice">
          Expert Advice
        </LinkV2>{' '}
        section for more guidance.
      </Fragment>
    ),
    question: 'Where should we start when planning a wedding?',
  },
  {
    answer:
      "Up to you! We’re here to help throughout your planning. The one thing we can't do? Be there on your wedding day, coordinating like a professional planner with a clipboard and headset. We'll be there in spirit!",
    question: 'Do we still need a wedding planner?',
  },
  {
    answer: (
      <Fragment>
        Most couples take about a year to plan their weddings. Whether you just got engaged or
        you&apos;ve booked your venue, our tools make this time as stress-free as possible no matter
        where you are on your journey. For more help, visit our{' '}
        <LinkV2 inline variant="tertiary" subtle href="/expert-advice">
          Expert Advice
        </LinkV2>{' '}
        section.
      </Fragment>
    ),
    question: 'How much time do you need to plan a wedding?',
  },
  {
    answer: (
      <Fragment>
        Absolutely! We suggest building your guest list and collecting addresses. Once you have a
        venue, date, and time, tell us and we&apos;ll keep you on schedule. Need help setting a date
        for your special day? Visit{' '}
        <LinkV2 inline variant="tertiary" subtle href="/expert-advice/choosing-your-wedding-month">
          this page
        </LinkV2>
        .
      </Fragment>
    ),
    question: 'Can we get started without a confirmed wedding date?',
  },
];
